// Runtime head updates for the SPA (CRA serves one static index.html, so
// crawlers that run JS and the browser tab get per-route values from here).
import { useEffect } from "react";

const ORIGIN = "https://www.duxtrans.com";

function setMeta(selector: string, attr: string, value: string) {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

/** Default head for the current route: title, description, canonical. */
export function applyRouteHead(pathname: string, title: string, description: string) {
  document.title = title;
  setMeta('meta[name="description"]', "content", description);
  const path = pathname !== "/" ? pathname.replace(/\/+$/, "") : "/";
  setMeta('link[rel="canonical"]', "href", `${ORIGIN}${path === "/" ? "/" : path}`);
}

/** Per-page title. Runs after the route default (child effects run later). */
export function useDocumentTitle(title: string | null | undefined) {
  useEffect(() => {
    if (title) document.title = title;
  }, [title]);
}

/** Adds <meta name="robots" content="noindex"> while mounted (404, closed roles). */
export function useNoIndex(active = true) {
  useEffect(() => {
    if (!active) return;
    const tag = document.createElement("meta");
    tag.name = "robots";
    tag.content = "noindex";
    document.head.appendChild(tag);
    return () => {
      tag.remove();
    };
  }, [active]);
}
